import {
  isPlainObject,
  mapKeys,
  mapValues,
  LodashSnakeCase,
  LodashCamelCase,
} from "lodash/fp";
import type { List } from "lodash";

export const mapKeysDeep =
  (cb: LodashCamelCase | LodashSnakeCase) =>
  (obj: Record<any, any> | List<any> | null | undefined): any =>
    Array.isArray(obj)
      ? obj.map(mapKeysDeep(cb))
      : isPlainObject(obj)
        ? mapValues(mapKeysDeep(cb))(mapKeys(cb)(obj))
        : obj;

export const result = async (
  promise: Promise<any>,
  handler?: (e: Error) => any,
): Promise<[Error | null, any]> => {
  try {
    const data = await promise;

    return [null, data];
  } catch (err) {
    if (typeof handler === "function") {
      return [handler(err as Error), null];
    }

    return [err as Error, null];
  }
};
